/**
 * The client types this error as the OAuth code set alone, but the refusals that
 * actually broke `hepha login` carry neither — a rate limiter answers a plain
 * message and a status. Hence reading defensively off `unknown`.
 */
export const deviceTokenError = {
  /** What the server said, when it said anything at all. */
  message(error: unknown): string | undefined {
    if (!error || typeof error !== "object") {
      return undefined;
    }
    const message = (error as { message?: unknown }).message;
    return typeof message === "string" && message.length > 0
      ? message
      : undefined;
  },

  /** Better Auth answers `X-Retry-After`, the platform the standard header. */
  retryAfter(error: unknown): number | undefined {
    if (!error || typeof error !== "object") {
      return undefined;
    }
    const headers = (error as { headers?: unknown }).headers;
    if (!(headers instanceof Headers)) {
      return undefined;
    }
    const raw =
      headers.get("x-retry-after") ?? headers.get("retry-after") ?? undefined;
    if (!raw) {
      return undefined;
    }
    const seconds = Number(raw.trim());
    return Number.isFinite(seconds) && seconds > 0 ? seconds : undefined;
  },
};
